import { usePopup } from 'hooks/usePopup'
import { useDispatch, useSelector } from 'react-redux'
import { Days, ISettingsRequest, settingsService } from 'services/settingsService'
import { IState } from 'store'
import { updateSettings as updateSettingsLocal } from 'store/reducers/settings/actions'

export const useConfig = () => {
  const dispatch = useDispatch()
  const { addPopup } = usePopup()

  const settings = useSelector<IState, ISettingsRequest>(state => state.settings)

  const getSetting = async () => {
    try {
      const dataSettings = await settingsService.getSettings()
      const dataSeparationGroups = await settingsService.getSeparationGroup()
      dispatch(
        updateSettingsLocal({
          ...dataSettings,
          numberOfSeparators: dataSettings?.number_of_separators || 0,
          goalSeparate: dataSettings?.goal_separate || 1,
          peakDays: dataSettings?.peak_days || [],
          separationGroups: dataSeparationGroups,
          palletLimitWeight: dataSettings?.pallet_limit_weight,
          palletLimitWholesaleBox: dataSettings?.pallet_limit_wholesale_box,
          PendingOrderBlocksLoading: dataSettings?.pending_order_blocks_loading,
          stickersByBox: dataSettings?.stickers_by_box || 1,
        }),
      )
    } catch {
      addPopup({
        type: 'error',
        title: 'Erro ao buscar configurações',
      })
    }
  }

  const updateSettings = async (value: {
    track?: number
    separation?: number
    separations?: number
    palletLimitWeight?: number
    palletLimitWholesaleBox?: number
    stickersByBox?: number
    numberOfSeparators?: number
    goalSeparate?: number
    peakDays?: Days[]
    PendingOrderBlocksLoading?: boolean
  }) => {
    try {
      // Envia apenas os campos alterados (em camelCase, como esperado pela API)
      const payload: Partial<ISettingsRequest> = {}

      Object.entries(value).forEach(([key, value]) => {
        if (value !== undefined) {
          payload[key as keyof Partial<ISettingsRequest>] = value as any
        }
      })

      await settingsService.updateSettings(payload)

      dispatch(updateSettingsLocal({ ...settings, ...value }))

      addPopup({
        type: 'success',
        title: 'Sucesso ao atualizar configurações',
      })

      getSetting()
    } catch {
      addPopup({
        type: 'error',
        title: 'Erro ao atualizar configuração',
      })
    }
  }

  return {
    getSetting,
    updateSettings,
  }
}
